import { Box, Typography } from "@mui/material";
import React from "react";

interface Props {
  text: string;
  status: "done" | "pending" | "inprogress";
  size?: "small" | "medum" | "large";
}

export default function BadgeStatus({ status, text, size }: Props) {
  const bgColor = status === "inprogress" ? "secondary.light" : "primary.light";
  const textColor = status === "inprogress" ? "secondary.main" : "info.main";
  const fontSize = size === "small" ? "10px" : "14px";
  const fontWeight = size === "small" ? 300 : 600;

  return (
    <Box
      sx={{
        width: "fit-content",
        paddingY: "4px",
        paddingX: "8px",
        backgroundColor: bgColor,
        borderRadius: "4px",
      }}
    >
      <Typography
        sx={{
          fontWeight: fontWeight,
          color: textColor,
          fontSize: fontSize,
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}
